<template>
  <footer class="app-footer">
    <span>Copyright &copy; {{ year() }} <a href="https://octamedia.pl">OCMD</a></span>
    <span class="ml-auto"></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  methods: {
    year () {
      const startedYear = 2022
      const currentYear = new Date().getFullYear()

      if (startedYear === currentYear) {
        return startedYear
      }
      return startedYear + '-' + currentYear
    }
  }
}
</script>
